import { createContext } from 'react';

import { IconMap } from 'helpers/iconRegistry';
import { IconSet } from 'types/icons';

export interface IIconSetContext {
  set: IconSet;
  icons: IconMap | null;
}

// Its own module so `hooks/useIconSet` can read the context without importing the provider back.
export const IconSetContext = createContext<IIconSetContext | null>(null);
